<template>
  <div :class="['tabs', {'showTab': showTab, 'isVn': isVn, 'isNotEn': isNotEn}]">
    <div
      :class="['item', { active: active == 'Schedule' }]"
      @click="$router.push({ name: 'Schedule' })"
    >
      <div>
        <img
          v-if="active == 'Schedule'"
          :src="require(`@/assets/imgs/comm/Schedule-active.svg`)"
          alt=""
        />
        <img v-else :src="require(`@/assets/imgs/comm/Schedule${
              theme == 'dark' ? '-active' : ''
            }.svg`)" alt="" />
        {{ $t("home.Schedule") }}
      </div>
    </div>
    <div
      :class="['item', { active: active == 'Integral' }]"
      @click="$router.push({ name: 'Integral' })"
    >
      <div>
        <img
          v-if="active == 'Integral'"
          :src="require(`@/assets/imgs/comm/Integral-active.svg`)"
          alt=""
        />
        <img
          v-else
          :src="
            require(`@/assets/imgs/comm/Integral${
              theme == 'dark' ? '-active' : ''
            }.svg`)
          "
          alt=""
        />
        {{ $t("home.Integral") }}
      </div>
    </div>
    <div
      :class="['item', { active: active == 'Player' }]"
      @click="$router.push({ name: 'Player' })"
    >
      <div>
        <img
          v-if="active == 'Player'"
          :src="require(`@/assets/imgs/comm/Player-active.svg`)"
          alt=""
        />
        <img
          v-else
          :src="
            require(`@/assets/imgs/comm/Player${
              theme == 'dark' ? '-active' : ''
            }.svg`)
          "
          alt=""
        />
        {{ $t("home.Player") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ['showTab'],
  name: "tabs",
  computed: {
    active() {
      return this.$route.name;
    },
    theme() {
      return this.common.theme;
    },
    isVn() {
      return this.$i18n.locale == "vn";
    },
    isNotEn() {
      return this.$i18n.locale != "en" && this.$i18n.locale != "cn";
    },
    ...mapState(["common"]),
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  opacity: 0;
  transition: .4s;
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 20;
  width: 298px;
  // background: url(../../assets/imgs/comm/navBg.png) no-repeat;
  background-size: 100% 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-10);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  backdrop-filter: blur(5px);
  border-radius: 30px;
  padding: 3px 0;

  &.isNotEn {
    width: 320px;
    .item {
      width: 105px;
    }
  }

  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #131a3e;
    width: 98px;
    height: 100%;
    font-size: 14px;
    font-weight: 600;
    padding: 0 4px;
    img {
      width: 18px;
      margin-right: 4px;
    }

    >div {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      white-space: nowrap;
    }
  }
  &.isVn{ 
    .item{
      font-size: 10px;
    }
  }
  .active {
    background: #F80000;
    color: #fff;
    border-radius: 30px;
  }
  .schedule {
    width: 56px;
    height: 57px;
    flex: none;
  }
  .schedule.active {
    background: none;
    color: #fff;
  }
  .scheduleBg {
    position: absolute;
    width: 56px;
    // top: -20px;
  }
  .wrap {
    position: relative;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 7px;
      margin-bottom: 2px;
    }
  }
}
.showTab{
  opacity: 1;
}
</style>

<style lang="scss">
.dark{
  .tabs{
    // background: rgba(37, 37, 37, 0.8);
  // filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  // backdrop-filter: blur(5px);
  background: url('../../assets/imgs/bar.png');
  background-size: 100% 100%;
  .item{
    color: #fff;
  }
  }
}
</style>